/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Order_NumberInputs */

const en_table_order_number = /** @type {(inputs: Table_Order_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order #`)
};

const es_table_order_number = /** @type {(inputs: Table_Order_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedido #`)
};

/**
* | output |
* | --- |
* | "Order #" |
*
* @param {Table_Order_NumberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_order_number = /** @type {((inputs?: Table_Order_NumberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Order_NumberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_order_number(inputs)
	return es_table_order_number(inputs)
});